import React, { useContext } from "react";
import { FormContext } from "../../App";
import { Controller } from "react-hook-form";
import Select, { OptionProps, ControlProps } from "react-select";
import Label from "../Label/Label";
import ErrorMessage from "../ErrorMessage/ErrorMessage";
import classNames from "classnames";
import style from "./Dropdown.module.css";

interface Option {
  label: string;
  value: number;
}
interface DropDownProps {
  name: string;
  options: Option[];
  label?: string;
  required?: boolean;
}

const customStyles = (hasError: boolean) =>
  ({
    container: (provided: Record<string, string>) => ({
      ...provided,
    }),
    control: (provided: Record<string, string>, state: ControlProps) => ({
      ...provided,
      fontFamily: "Inter",
      borderRadius: "4px",
      height: "44px",
      border: "1px solid #D8DCE6",
      borderColor: hasError ? "#f24640;" : "#D8DCE6",
      opacity: state.isDisabled ? 0.4 : 1,
      marginTop: "8px",
    }),
    option: (provided: Record<string, string>, state: OptionProps) => ({
      ...provided,
      fontFamily: "Inter",
      "&:hover": {
        background: state.isSelected ? "#0094E1" : "#f5f5f5",
      },
      background: state.isSelected ? "#00A7FF" : "white",
    }),
    menu: (provided: Record<string, string>) => ({
      ...provided,
      minWidth: "100%",
      width: "auto",
      borderRadius: 0,
    }),
    menuList: (provided: Record<string, string>) => ({
      ...provided,
      padding: 0,
    }),
    indicatorSeparator: () => ({ display: "none" }),
  } as any);

const Dropdown: React.FC<DropDownProps> = ({
  name,
  label,
  options,
  required,
}) => {
  const { control, errors } = useContext(FormContext);
  return (
    <div>
      {label && <Label text={label} required={required} />}
      <Controller
        name={name}
        rules={{
          required: required && "Required field",
        }}
        control={control}
        render={({ field: { onChange } }) => (
          <Select
            className={classNames({ [style.error]: errors[name] })}
            classNamePrefix="react-select"
            styles={customStyles(errors[name])}
            placeholder="Please select"
            options={options}
            onChange={(option) => onChange(option?.value)}
          />
        )}
      />
      <ErrorMessage name={name} />
    </div>
  );
};
export default Dropdown;
